<style lang="scss" scoped>
::v-deep .success-message {
    @apply text-gray-300;
}
</style>

<template>
    <div class="contact-form form max-w-[30rem]" ref="form" :class="{ processing: processing }">
        <ValidationObserver v-if="!submitted" v-slot="obs" ref="observer" tag="form" @submit.prevent="submit('/api/contact')">
            <ValidationProvider ref="first_name" vid="first_name" rules="required|min:2" v-slot="props" :name="translations.first_name" :slim="true">
                <div class="relative mb-md" :class="props.classes">
                    <label class="text-md mb-xs inline-block" for="first_name">{{ translations.first_name }}</label>
                    <input type="text" id="first_name" class="form__input form__input--lg" :placeholder="translations.first_name_placeholder" v-model="formData.first_name" />
                    <span v-if="props.errors && props.errors.length" class="text-red text-xs leading-none inline-block">{{ props.errors[0] }}</span>
                </div>
            </ValidationProvider>
            <ValidationProvider ref="name" vid="name" rules="required|min:2" v-slot="props" :name="translations.name" :slim="true">
                <div class="relative mb-md" :class="props.classes">
                    <label class="text-md mb-xs inline-block" for="name">{{ translations.name }}</label>
                    <input type="text" id="name" class="form__input form__input--lg" :placeholder="translations.name_placeholder" v-model="formData.name" />
                    <span v-if="props.errors && props.errors.length" class="text-red text-xs leading-none inline-block">{{ props.errors[0] }}</span>
                </div>
            </ValidationProvider>
            <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="translations.email" :slim="true">
                <div class="relative mb-md" :class="props.classes">
                    <label class="text-md mb-xs inline-block" for="email">{{ translations.email }}</label>
                    <input type="email" id="email" class="form__input form__input--lg" :placeholder="translations.email_placeholder" v-model="formData.email" />
                    <span v-if="props.errors && props.errors.length" class="text-red text-xs leading-none inline-block">{{ props.errors[0] }}</span>
                </div>
            </ValidationProvider>
            <ValidationProvider
                ref="phone"
                vid="phone"
                :rules="{
                    required: true,
                    regex: /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/,
                }"
                v-slot="props"
                :name="translations.phone"
                :slim="true"
            >
                <div class="relative mb-md" :class="props.classes">
                    <label class="text-md mb-xs inline-block" for="phone">{{ translations.phone }}</label>
                    <input type="text" id="phone" class="form__input form__input--lg" :placeholder="translations.phone_placeholder" v-model="formData.phone" />
                    <span v-if="props.errors && props.errors.length" class="text-red text-xs leading-none inline-block">{{ props.errors[0] }}</span>
                </div>
            </ValidationProvider>
            <ValidationProvider ref="comment" vid="comment" rules="required|min:5" v-slot="props" :name="translations.comment" :slim="true">
                <div class="relative mb-md" :class="props.classes">
                    <label class="text-md mb-xs inline-block" for="comment">{{ translations.message }}</label>
                    <textarea id="comment" class="form__input form__input--textarea form__input--lg" :placeholder="translations.message_placeholder" v-model="formData.comment" />
                    <span v-if="props.errors && props.errors.length" class="text-red text-xs leading-none inline-block mb-2">{{ props.errors[0] }}</span>
                </div>
            </ValidationProvider>
            <ValidationProvider ref="newsletter" vid="newsletter" v-slot="props" :name="translations.newsletter" :slim="true">
                <div class="relative mb-md" :class="props.classes">
                    <div class="form__checkbox form__checkbox--filled-dark flex">
                        <input type="checkbox" id="newsletter" :placeholder="translations.newsletter" v-model="formData.newsletter" />
                        <span class="translate-y-[6px]" @click="checkboxSpanClicked"></span>
                        <label for="newsletter">{{ translations.newsletter }}</label>
                    </div>
                    <span v-if="props.errors && props.errors.length" class="text-red text-xs leading-none inline-block mb-2">{{ props.errors[0] }}</span>
                </div>
            </ValidationProvider>
            <button type="submit" :disabled="processing" class="btn btn--primary btn--filled">
                <span>{{ translations.submit }}</span>
                <i v-if="processing" class="fa-regular fa-spinner-third animate-spin"></i>
            </button>
            <span v-if="compiledErrors && compiledErrors.length" class="error text-red text-xs leading-none inline-block mb-5">{{ compiledErrors[0] }}</span>
        </ValidationObserver>
        <div v-else>
            <p class="success-message">{{ translations.success_message }}</p>
        </div>
    </div>
</template>

<script>
import formBaseRecaptcha from '@/mixins/formBaseRecaptcha';

export default {
    mixins: [formBaseRecaptcha],

    data() {
        return {
            formData: {
                first_name: '',
                name: '',
                email: '',
                phone: '',
                comment: '',
                newsletter: false,
                language: document.documentElement.lang,
            },
        };
    },

    methods: {
        checkboxSpanClicked(e) {
            e.target.nextSibling.nextSibling.click();
        },
    },
};
</script>
